import { useDynamicContext } from "@dynamic-labs/sdk-react-core";
import { useQuery } from "@tanstack/react-query";

import { fetchUser } from "../dynamic.service";

export const useKyanSmartAccounts = () => {
  const { user } = useDynamicContext();
  const userId = user?.userId;

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["fetchUser", userId],
    queryFn: () => fetchUser(userId!),
    enabled: Boolean(userId),
    select: (response) =>
      response.data?.user?.metadata?.kyanSmartAccounts || [],
    staleTime: 30_000,
  });

  return {
    kyanSmartAccounts: data || [],
    isLoading,
    refetch,
  };
};
